import React, { useCallback } from 'react';
import type { ICellRendererParams } from 'ag-grid-community';

import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

const PreviewCellRenderer: React.FC<ICellRendererParams> = ({ data, context, colDef, api, node }) => {
  const { id } = data;

  const {
    components: {
      [colDef!.cellRenderer as string]: { onClickPreview, onClickPayment },
    },
  } = context;

  const handlePreviewClick = useCallback(() => {
    onClickPreview(id);

    // it is way hard row resetting allows us to avoid grid's scrolling during navigation preview by arrow keys
    api.redrawRows({ rowNodes: [node] });
  }, [onClickPreview, api, node, id]);

  const handleOpenPayment = useCallback(() => {
    onClickPayment(id);
  }, [onClickPayment, id]);

  return (
    <Stack flex={1} direction="row" justifyContent="center" alignItems="center">
      <IconButton onClick={handlePreviewClick} sx={{ fontSize: '22px' }}>
        <RemoveRedEyeOutlinedIcon fontSize="inherit" />
      </IconButton>
      <IconButton onClick={handleOpenPayment} sx={{ fontSize: '22px' }}>
        <InsertDriveFileOutlinedIcon fontSize="inherit" />
      </IconButton>
    </Stack>
  );
};

export default PreviewCellRenderer;
